import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { abortableDelay } from '../../abortableDelay';
import { WaitNodeView } from '../views/WaitNode';
import { WaitSettings } from '../settings/WaitSettings';

const isValidSeconds = (seconds: number): boolean => {
  if (!Number.isFinite(seconds) || seconds < 0 || seconds > 60) return false;
  const tenths = seconds * 10;
  return Math.abs(tenths - Math.round(tenths)) < 1e-8;
};

const formatSeconds = (seconds: number): string =>
  Number.isInteger(seconds) ? String(seconds) : seconds.toFixed(1);

export const waitDefinition: NodeDefinition<'wait'> = {
  label: 'Wait',
  showInPalette: true,
  paletteColor: 'bg-blue-100 border-blue-500 text-blue-700',
  miniMapColor: '#3b82f6',
  defaultData: { label: 'Wait', seconds: 1 },
  view: WaitNodeView,
  settings: WaitSettings,
  run: async (node, ctx, log) => {
    const seconds = node.data.seconds ?? 1;
    if (!isValidSeconds(seconds)) {
      log('[Wait] エラー: 秒数は0〜60の範囲で0.1秒単位にしてください');
      return { nextHandle: null };
    }

    const result = await abortableDelay(seconds * 1000, ctx.signal);
    if (result === 'completed') {
      log(`[Wait] ${formatSeconds(seconds)}秒待ちました`);
    }
  },
  help: {
    title: [t('Wait（'), r('待', 'ま'), t('つ）')],
    description: [
      r('決', 'き'),
      t('めた'),
      r('秒数', 'びょうすう'),
      t('だけ'),
      r('止', 'と'),
      t('まって'),
      r('待', 'ま'),
      t('ちます。'),
      r('待', 'ま'),
      t('ち'),
      r('終', 'お'),
      t('わったら、つぎのカードへ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
